exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mu-dialog-title {\n  color: #005296;\n  justify-content: space-around;\n  border-top: black;\n}\n.mu-dialog-fullscreen {\n  max-width: 78% !important;\n  max-height: 86% !important;\n  position: initial;\n}\n.mu-dialog-scrollable .mu-dialog-body {\n  height: inherit;\n}", ""]);

// exports
